<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row>
          <el-col :span="24">
            <div>系统消息</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label+item.num" :key="index" :name="item.name" class="tab-item">
                <ApeTable ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" @selectList="selectList" highlight-current-row >
                  <!-- <el-table-column
                    slot="first-column"
                    type="selection"
                    width="55">
                  </el-table-column> -->
                  <el-table-column
                    slot="second-column"
                    align="center"
                    label="主题">
                    <template slot-scope="scope">
                      <el-button type="text"
                        @click="showTheme(scope.row.content)" :class=" scope.row.is_top ? 'add-color' : ''">
                        {{ scope.row.is_top ? '[置顶] ' : '' }}客户系统升级公告  （{{ scope.row.created_at | DateTime}}）
                      </el-button>
                    </template>
                  </el-table-column>
                </ApeTable>
                <!-- <el-button class="sign" type="primary" :disabled="isMarked" @click="markRead">标记为已读</el-button> -->
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </div>
    </PageHeaderLayout>
     <!-- 预览主题公告 -->
     <NoticeDialog :dialogVisible="customerVisible" :allowField="allowField" :htmlData="htmlData" @know="know" @handleClose="handleClose"/>
  </div>
</template>

<script>
/* eslint-disable */
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from '@/components/ApeTable'
import NoticeDialog from '@/components/NoticeDialog'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    NoticeDialog
  },
  data() {
    return {
      isColor: false,
      customerVisible: false,//查看主题公告弹框是否显示
      htmlData: '',
      allowField: ['notice'],
      activeName: 'all',
      tabsList: [
        {
          label: '全部',
          name: 'all',
          num: ''
        },
        // {
        //   label: '未读',
        //   name: 'unread',
        //   num: '12'
        // },
        // {
        //   label: '已读',
        //   name: 'read',
        //   num: '8'
        // },
      ],
      columns: [
        {
          title: '发布时间',
          value: 'created_at',
          header_align: 'center',
          align: 'center'
        }
      ],
      dataList: [],
      idList: [],
      isMarked: true,
      loadingStaus: false,
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 搜索条件
      searchCondition:{},
      pagingInfo: {},
      total: 0
    };
  },
  watch: {
    "$route.matched": function(n, o) {
      console.log(o,"ooooo");
      if (n.length === 2) {
        this.initCompanyList();
      }
    },
  },
  mounted() {
    this.getId()
    this.init()
  },
  methods: {
    know() {
      this.customerVisible = false
    },
    handleClose() {
      this.customerVisible = false
    },
    async getId() {
      let data = await this.$api.getPrice()
      this.searchCondition.id = data.account.id
      this.htmlData= data.announcement.content
      this.init()
    },
    async init(type) {
      this.loadingStaus=true
      var pagingInfo = this.$refs['apeTable'][0].getPagingInfo(type)
      if(type) {
        pagingInfo.current_page = 1
      }
      var searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let {list,pages} = await this.$api.getAnnouncementList(searchCondition)
      this.dataList = list
      this.total = list.length
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      // if (this.searchCondition.id) {
      //   condition.id = this.searchCondition.id
      // }
      return condition
    },
    /* 查看主题信息 */
    showTheme(content) {
      this.customerVisible = true
      this.htmlData = content
    },
    //获取tab切换数目
    getTabNum(name) {
      console.log(name,"name")
      this.tabsList.forEach((item) => {
        if(name == item.name) {
          item.num = this.total
        }
      })
    },
    async handleClick() {
      if( this.activeName == 'all' ) {
        this.init('all')
        this.getTabNum('all')
      }else if( this.activeName == 'unread') {
        this.init('unread')
        this.getTabNum('unread')
      }else if( this.activeName == 'read' ) {
        this.init('read')
        this.getTabNum('read')
      }
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
    //选中多选按钮
    async selectList(list) {
      list.forEach(item => {
        this.idList.push(item.id)
      });
      //数组去重
      this.idList = [...new Set(this.idList)]
      if(list.length != 0) {
        this.isMarked = false
      }else {
        this.isMarked = true
      }
    },
    markRead() {
      console.log('已读')
    }
  }
};
</script>

<style lang="stylus" scoped>
  .sign
    margin: 20px 0
  .upgrade-title/deep/.el-dialog__title
    display:flex
    justify-content: center
  .dialog-footer
    display: flex
    justify-content: center
  .add-color
    color: #f56c6c
</style>
